let activeUser: { token: string; id?: number } | null = null

export const setActiveUser = (user: { token: string; id?: number }) => {
  activeUser = user
}

export const getActiveUser = () => activeUser

export const clearActiveUser = () => {
  activeUser = null
}
